var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.network",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{attrs:{"color":_vm.getColor(item.network)}},[_vm._v("mdi-checkbox-blank-circle")])]}}],null,true)})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }